import { ColumnDef } from "@tanstack/react-table";
import { DataTable } from "components/data-table";
import styles from "./styles.module.scss";

export interface SummaryTableItem {
  category: string;
  verdict: string;
  comment: string;
}

interface SummaryTableProps {
  tableBodyItems: SummaryTableItem[];
  /** @deprecated No longer used — kept for backward compatibility */
  tableBodyItemClassName?: string;
  /** @deprecated No longer used — kept for backward compatibility */
  tableBodyRowClassName?: string;
}

const columns: ColumnDef<SummaryTableItem, unknown>[] = [
  {
    id: "category",
    header: "Category",
    meta: { className: "flex-1" },
    cell: ({ row }) => (
      <div className="flex flex-col items-start gap-2 py-3 text-[#1D2939] font-medium">
        {row.original.category}
        {/* Mobile verdict badge — shown only below sm */}
        <span className="sm:hidden flex">
          <p
            className={`px-3 py-1 text-xs rounded-xl ${styles.verdict} ${
              styles[row.original.verdict.toLowerCase().replace(" ", "-")]
            }`}
          >
            {row.original.verdict}
          </p>
        </span>
      </div>
    ),
  },
  {
    id: "verdict",
    header: "Verdict",
    meta: { className: "hidden sm:flex flex-[0.6] items-stretch" },
    cell: ({ row }) => (
      <div className="hidden sm:flex items-center self-stretch py-[22px]">
        <p
          className={`px-3 py-1 text-sm font-medium whitespace-nowrap rounded-2xl ${styles.verdict} ${
            styles[row.original.verdict.toLowerCase().replace(" ", "-")]
          }`}
        >
          {row.original.verdict}
        </p>
      </div>
    ),
  },
  {
    id: "comment",
    header: "Comment",
    meta: { className: "flex-1" },
    cell: ({ row }) => (
      <div className="py-3 text-[#344054] font-light">
        {row.original.comment}
      </div>
    ),
  },
];

const SummaryTable: React.FC<SummaryTableProps> = ({ tableBodyItems }) => {
  return (
    <DataTable
      columns={columns}
      data={tableBodyItems}
      rowBaseClassName={(_, index) =>
        `text-[13px] md:text-[15px] border-b border-[#EAECF0] last:border-b-0 ${
          index % 2 === 0 ? "bg-[#F9FAFB]" : "bg-white"
        }`
      }
      cellBaseClassName="px-4 align-top [&:not(:last-child)]:border-r [&:not(:last-child)]:border-[#EAECF0]"
      headerCellClassName="px-4 py-3 text-left border-b border-[#EAECF0] [&:not(:last-child)]:border-r [&:not(:last-child)]:border-[#EAECF0]"
      headerClassName="text-[13px] font-medium text-neutral-500"
    />
  );
};

export { SummaryTable };
